/**
 * Copyright IBM Corp. 2025, 2025
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { html } from 'lit';
import { prefix } from '../../../globals/settings';

const componentName = 'full-page-error';
const blockClass = `${prefix}--${componentName}`;

export const errorGenericSVG = html`<svg
  class=${`${blockClass}__svg ${blockClass}__custom`}
  viewBox="0 0 750 506"
  fill="none"
  aria-hidden="true"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clipPath="url(#clip0_203_144)">
    <path
      d="M51.6493 119.887H669.705C671.623 119.887 673.177 121.441 673.177 123.359V133.776H48.1771V123.359C48.1771 121.441 49.7309 119.887 51.6493 119.887Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M58.5938 130.269C60.5114 130.269 62.066 128.722 62.066 126.814C62.066 124.906 60.5114 123.359 58.5938 123.359C56.6761 123.359 55.1215 124.906 55.1215 126.814C55.1215 128.722 56.6761 130.269 58.5938 130.269Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M69.0104 130.304C70.9281 130.304 72.4826 128.749 72.4826 126.832C72.4826 124.914 70.9281 123.359 69.0104 123.359C67.0928 123.359 65.5382 124.914 65.5382 126.832C65.5382 128.749 67.0928 130.304 69.0104 130.304Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M79.4271 130.304C81.3447 130.304 82.8993 128.749 82.8993 126.832C82.8993 124.914 81.3447 123.359 79.4271 123.359C77.5094 123.359 75.9549 124.914 75.9549 126.832C75.9549 128.749 77.5094 130.304 79.4271 130.304Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path d="M48.1771 320.273V133.776H673.177" fill="#F3F3F3" />
    <path
      d="M48.1771 320.273V133.776H673.177"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M426.649 467.109V300.443H700.087C711.593 300.443 720.92 309.77 720.92 321.276V426.376"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M180.122 467.109V300.443H426.649V505.373H659.288"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M618.546 300.443H426.649V133.776H673.177"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M426.649 133.776H180.122V300.443H426.649V133.776Z"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path d="M48.1771 133.776H180.122V467.109" fill="#F3F3F3" />
    <path
      d="M48.1771 133.776H180.122V467.109"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M141.927 178.915H75.9549V244.887H141.927V178.915Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeLinejoin="round"
    />
    <path
      d="M141.927 255.304H75.9549V321.276H141.927V255.304Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M98.5243 270.061C98.5243 272.938 96.1936 275.269 93.316 275.269C90.4384 275.269 88.1076 272.938 88.1076 270.061C88.1076 267.183 90.4384 264.852 93.316 264.852C96.1936 264.852 98.5243 267.183 98.5243 270.061ZM127.17 288.29C127.17 291.168 124.839 293.498 121.962 293.498C119.084 293.498 116.753 291.168 116.753 288.29C116.753 285.412 119.084 283.082 121.962 283.082C124.839 283.082 127.17 285.412 127.17 288.29ZM82.8993 270.061H87.8472H82.8993ZM98.5243 270.061H134.983H98.5243ZM116.753 288.29H82.8993H116.753ZM127.17 288.29H134.983H127.17ZM114.149 306.519C114.149 309.397 111.819 311.727 108.941 311.727C106.063 311.727 103.733 309.397 103.733 306.519C103.733 303.641 106.063 301.311 108.941 301.311C111.819 301.311 114.149 303.641 114.149 306.519ZM103.733 306.519H82.8993H103.733ZM114.149 306.519H134.983H114.149Z"
      fill="#F3F3F3"
    />
    <path
      d="M98.5243 270.061C98.5243 272.938 96.1936 275.269 93.316 275.269C90.4384 275.269 88.1076 272.938 88.1076 270.061C88.1076 267.183 90.4384 264.852 93.316 264.852C96.1936 264.852 98.5243 267.183 98.5243 270.061ZM98.5243 270.061H134.983M127.17 288.29C127.17 291.168 124.839 293.498 121.962 293.498C119.084 293.498 116.753 291.168 116.753 288.29M127.17 288.29C127.17 285.412 124.839 283.082 121.962 283.082C119.084 283.082 116.753 285.412 116.753 288.29M127.17 288.29H134.983M116.753 288.29H82.8993M82.8993 270.061H87.8472M114.149 306.519C114.149 309.397 111.819 311.727 108.941 311.727C106.063 311.727 103.733 309.397 103.733 306.519M114.149 306.519C114.149 303.641 111.819 301.311 108.941 301.311C106.063 301.311 103.733 303.641 103.733 306.519M114.149 306.519H134.983M103.733 306.519H82.8993"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M141.927 331.693H75.9549V397.665H141.927V331.693Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M122.483 360.165H95.3993C90.434 360.165 86.3715 356.102 86.3715 351.137C86.3715 346.172 90.434 342.109 95.3993 342.109H122.483C127.448 342.109 131.51 346.172 131.51 351.137C131.51 356.102 127.448 360.165 122.483 360.165ZM131.51 378.22C131.51 373.255 127.448 369.193 122.483 369.193H95.3993C90.434 369.193 86.3715 373.255 86.3715 378.22C86.3715 383.186 90.434 387.248 95.3993 387.248H122.483C127.448 387.248 131.51 383.186 131.51 378.22ZM95.3993 346.623C92.908 346.623 90.8854 348.646 90.8854 351.137C90.8854 353.628 92.908 355.651 95.3993 355.651C97.8906 355.651 99.9132 353.628 99.9132 351.137C99.9132 348.646 97.8906 346.623 95.3993 346.623ZM122.483 373.707C119.991 373.707 117.969 375.729 117.969 378.22C117.969 380.712 119.991 382.734 122.483 382.734C124.974 382.734 126.997 380.712 126.997 378.22C126.997 375.729 124.974 373.707 122.483 373.707Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M110.677 147.665H75.9549V154.609H110.677V147.665Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M131.51 161.554H75.9549V168.498H131.51V161.554Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M16.9271 383.776H243.49V467.109H37.7604C26.263 467.109 16.9271 457.773 16.9271 446.276V383.776Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M196.541 369.44H189.371V370.872H196.541V369.44Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M243.307 243.233C243.207 242.708 242.7 242.348 242.179 242.465C242.135 242.474 239.692 247.196 236.862 247.253L233.047 246.918C232.786 246.897 232.665 246.58 232.847 246.389C232.847 246.389 234.267 244.826 237.552 244.245C238.329 244.106 238.806 243.286 238.832 242.496L238.841 242.235L231.146 243.008L225.291 245.065C225.291 245.065 223.841 244.978 221.949 244.865L221.567 251.536C223.668 251.272 224.931 251.089 224.931 251.089C225.26 251.146 230.508 251.424 233.963 251.632C236.975 251.814 240.074 250.486 242.678 245.052C242.856 244.683 243.385 243.654 243.303 243.238L243.307 243.233Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M213.45 379.171C210.699 378.468 202.591 376.671 200.321 375.169C197.791 373.503 196.536 370.872 196.536 370.872C196.536 368.893 194.93 367.287 192.951 367.287C190.972 367.287 189.366 368.893 189.366 370.872C189.175 373.997 188.85 376.597 188.85 379.466C188.85 381.05 190.134 382.335 191.719 382.335H213.047C213.937 382.335 214.657 381.615 214.657 380.725C214.657 379.991 214.162 379.349 213.446 379.167L213.45 379.171Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M216.884 382.339C216.884 379.601 209.996 377.24 208.537 376.623C207.392 376.141 199.831 373.086 198.889 372.313C198.815 372.253 198.589 372.036 198.342 371.788C198.26 371.706 198.173 371.619 198.086 371.532C197.977 371.424 197.839 371.376 197.704 371.385C197.661 371.385 197.617 371.398 197.574 371.411C197.405 371.467 197.27 371.615 197.248 371.823C197.205 372.235 197.183 372.674 197.109 373.06C197.031 373.446 196.901 373.78 196.641 373.98C195.673 374.722 194.471 375.165 193.155 375.165C191.563 375.165 190.2 374.783 189.158 373.733C188.42 375.673 188.212 379.11 188.212 382.335H188.194V383.767H216.888V382.335L216.884 382.339Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M161.567 370.317C163.547 370.317 165.152 368.712 165.152 366.732C165.152 364.752 163.547 363.147 161.567 363.147C159.587 363.147 157.982 364.752 157.982 366.732C157.982 368.712 159.587 370.317 161.567 370.317Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M176.589 380.733C176.589 381.623 175.868 382.344 174.978 382.344H165.911L155.226 378.064C153.767 377.448 153.086 375.764 153.702 374.306C154.818 371.667 155.898 369.158 158.264 365.343L164.87 368.129C164.87 368.129 164.41 370.53 166.497 373.485C167.504 374.909 167.882 375.26 170.434 377.708C171.866 379.084 174.392 378.924 175.382 379.18C176.094 379.362 176.593 380.004 176.593 380.738L176.589 380.733Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M178.034 382.339C178.034 378.021 171.576 377.756 170.469 376.623C169.601 375.729 166.298 372.687 165.734 371.61C165.725 371.597 165.716 371.576 165.703 371.549C165.681 371.502 165.651 371.432 165.616 371.35C165.582 371.267 165.543 371.172 165.499 371.072C165.456 370.968 165.412 370.859 165.365 370.747C165.343 370.69 165.321 370.634 165.295 370.577C165.139 370.191 164.605 370.156 164.405 370.521C164.358 370.612 164.306 370.703 164.258 370.799C164.063 371.172 163.863 371.554 163.624 371.836C163.446 372.049 163.247 372.209 163.008 372.27C161.827 372.578 160.547 372.517 159.336 372.01C157.869 371.389 156.793 370.23 156.246 368.858C154.722 370.742 152.543 373.394 151.293 376.35L150.66 377.591L165.916 383.772H178.043V382.339"
      fill="#F3F3F3"
    />
    <path
      d="M178.034 382.339C178.034 378.021 171.576 377.756 170.469 376.623C169.601 375.729 166.298 372.687 165.734 371.61C165.725 371.597 165.716 371.576 165.703 371.549C165.681 371.502 165.651 371.432 165.616 371.35C165.582 371.267 165.543 371.172 165.499 371.072C165.456 370.968 165.412 370.859 165.365 370.747C165.343 370.69 165.321 370.634 165.295 370.577C165.139 370.191 164.605 370.156 164.405 370.521C164.358 370.612 164.306 370.703 164.258 370.799C164.063 371.172 163.863 371.554 163.624 371.836C163.446 372.049 163.247 372.209 163.008 372.27C161.827 372.578 160.547 372.517 159.336 372.01C157.869 371.389 156.793 370.23 156.246 368.858C154.722 370.742 152.543 373.394 151.293 376.35L150.66 377.591L165.916 383.772H178.043V382.339"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M222.183 205.443C221.641 204.275 222.817 203.325 223.555 203.299C224.284 203.277 225.239 203.333 225.881 203.468L226.233 203.52C226.519 203.559 226.806 203.52 227.07 203.407L227.261 203.325L228.047 202.717L229.115 202.695C229.115 202.695 229.275 202.496 229.249 202.322C229.175 201.884 228.715 201.68 228.299 201.528L225.755 200.356L222.261 201.463L221.862 203.815C221.862 203.815 221.536 204.492 221.766 205.048C221.797 205.117 222.179 205.451 222.179 205.451L222.183 205.443Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M212.096 211.905L214.11 209.813C214.314 209.601 214.496 209.371 214.653 209.128L218.585 202.99C218.85 202.578 219.197 202.222 219.601 201.944L224.462 198.516C224.839 198.251 225.308 198.16 225.76 198.264C225.76 198.264 228.077 198.902 228.867 199.141C229.436 199.314 231.076 199.8 231.141 200.226C231.185 200.521 230.46 201.467 229.319 201.155L226.849 200.451C226.371 200.334 225.864 200.191 225.473 200.495C224.8 201.02 223.459 202.157 222.452 202.999C221.81 203.537 221.324 204.653 222.361 205.629C223.233 206.45 224.232 205.694 224.835 205.252C226.068 204.353 226.888 203.589 227.847 202.856C228.368 202.431 228.863 202.435 229.266 202.813C229.67 203.19 229.687 203.828 229.31 204.232L228.338 205.265L228.372 205.226L224.036 209.835C223.685 210.204 222.782 210.655 222.348 210.92C221.415 211.489 219.167 212.882 218.637 213.446C217.708 214.431 216.302 215.929 216.302 215.929"
      fill="#F3F3F3"
    />
    <path
      d="M212.096 211.905L214.11 209.813C214.314 209.601 214.496 209.371 214.653 209.128L218.585 202.99C218.85 202.578 219.197 202.222 219.601 201.944L224.462 198.516C224.839 198.251 225.308 198.16 225.76 198.264C225.76 198.264 228.077 198.902 228.867 199.141C229.436 199.314 231.076 199.8 231.141 200.226C231.185 200.521 230.46 201.467 229.319 201.155L226.849 200.451C226.371 200.334 225.864 200.191 225.473 200.495C224.8 201.02 223.459 202.157 222.452 202.999C221.81 203.537 221.324 204.653 222.361 205.629C223.233 206.45 224.232 205.694 224.835 205.252C226.068 204.353 226.888 203.589 227.847 202.856C228.368 202.431 228.863 202.435 229.266 202.813C229.67 203.19 229.687 203.828 229.31 204.232L228.338 205.265L228.372 205.226L224.036 209.835C223.685 210.204 222.782 210.655 222.348 210.92C221.415 211.489 219.167 212.882 218.637 213.446C217.708 214.431 216.302 215.929 216.302 215.929"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M291.233 178.915H225.26V244.887H291.233V178.915Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M277.565 217.036L275.521 221.918L280.291 226.684L273.03 233.945L268.277 229.193L263.381 231.202V237.943H253.112V231.22L248.229 229.18L243.464 233.945L236.202 226.684L240.955 221.931L238.945 217.036H232.205V206.766H238.928L240.972 201.884L236.207 197.114L243.468 189.852L248.221 194.605L253.116 192.595V185.855H263.385V192.578L268.268 194.618L273.034 189.852L280.295 197.114L275.543 201.866L277.552 206.762H284.293V217.031H277.569L277.565 217.036ZM258.247 199.748C251.536 199.748 246.094 205.191 246.094 211.901C246.094 218.611 251.536 224.054 258.247 224.054C264.957 224.054 270.399 218.611 270.399 211.901C270.399 205.191 264.957 199.748 258.247 199.748Z"
      stroke="black"
      strokeWidth="0.918981"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M222.543 205.777C223.416 206.597 224.049 205.781 224.653 205.343C225.885 204.444 226.706 203.681 227.665 202.947C228.186 202.522 228.681 202.526 229.084 202.904C229.488 203.281 229.505 203.919 229.128 204.323L228.155 205.356L228.19 205.317L223.854 209.926C223.503 210.295 222.6 210.747 222.166 211.011C221.233 211.58 218.984 212.973 218.455 213.537"
      fill="#F3F3F3"
    />
    <path
      d="M222.543 205.777C223.416 206.597 224.049 205.781 224.653 205.343C225.885 204.444 226.706 203.681 227.665 202.947C228.186 202.522 228.681 202.526 229.084 202.904C229.488 203.281 229.505 203.919 229.128 204.323L228.155 205.356L228.19 205.317L223.854 209.926C223.503 210.295 222.6 210.747 222.166 211.011C221.233 211.58 218.984 212.973 218.455 213.537"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M184.136 199.444L199.427 221.003C200.499 222.201 202.001 221.367 202.96 220.477L213.199 210.399C213.199 210.399 217.318 215.456 217.795 216.615L206.115 234.549C203.238 237.856 199.423 236.797 198.455 235.964L174.505 209.714C173.177 208.568 169.067 203.247 173.55 198.915L166.137 192.769C170.946 188.598 182.908 198.199 184.136 199.449V199.444Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M236.862 247.253L233.047 246.918C232.786 246.897 232.665 246.58 232.847 246.389C232.847 246.389 234.267 244.826 237.552 244.245C238.329 244.106 238.806 243.286 238.832 242.496L238.841 242.235L231.146 243.008L225.291 245.065C225.291 245.065 223.841 244.978 221.949 244.865L221.567 251.536"
      fill="#F3F3F3"
    />
    <path
      d="M236.862 247.253L233.047 246.918C232.786 246.897 232.665 246.58 232.847 246.389C232.847 246.389 234.267 244.826 237.552 244.245C238.329 244.106 238.806 243.286 238.832 242.496L238.841 242.235L231.146 243.008L225.291 245.065C225.291 245.065 223.841 244.978 221.949 244.865L221.567 251.536"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M201.228 276.246H174.514L168.993 210.143L194.062 213.715L204.058 272.904C204.353 274.653 203.003 276.25 201.233 276.25L201.228 276.246Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M188.424 170.317C189.514 162.882 184.375 155.972 176.94 154.883C169.505 153.793 162.595 158.932 161.506 166.367C161.068 169.366 161.641 172.283 162.973 174.761C165.807 183.867 159.918 192.752 158.29 198.338L175.061 198.911C175.061 198.911 173.168 190.994 176.814 186.944L181.302 187.604L182.799 187.826C184.453 188.069 185.985 186.927 186.228 185.273L187.105 179.293L188.524 178.997C189.345 178.802 189.692 178.008 189.427 177.205L187.982 173.312L188.42 170.321L188.424 170.317Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M187.782 161.753C187.947 161.458 188.06 161.133 188.112 160.777C188.303 159.414 187.496 158.142 186.246 157.704C186.246 157.687 186.254 157.669 186.254 157.648C186.471 156.094 185.391 154.657 183.837 154.44C183.576 154.405 183.316 154.405 183.064 154.44C182.804 153.333 181.888 152.448 180.694 152.279C180.061 152.187 179.449 152.322 178.928 152.608C178.511 151.853 177.756 151.293 176.836 151.163C175.916 151.033 175.035 151.363 174.427 151.975C174.006 151.554 173.451 151.259 172.817 151.172C171.623 151.003 170.503 151.606 169.944 152.595C169.714 152.496 169.466 152.422 169.201 152.383C167.648 152.166 166.211 153.247 165.994 154.8C165.994 154.818 165.994 154.839 165.99 154.857C164.666 154.935 163.542 155.937 163.351 157.296C163.316 157.556 163.316 157.817 163.351 158.069C162.244 158.329 161.359 159.245 161.189 160.438C161.102 161.072 161.233 161.684 161.519 162.205C160.764 162.622 160.204 163.377 160.074 164.297C159.944 165.217 160.273 166.098 160.89 166.706C160.135 167.122 159.575 167.878 159.444 168.798C159.275 169.991 159.878 171.111 160.872 171.671C160.773 171.901 160.699 172.148 160.66 172.413C160.464 173.819 161.328 175.122 162.643 175.521C163.099 176.866 163.468 177.769 163.468 177.769C164.006 178.242 169.9 178.594 171.879 175.855L174.449 172.088C174.549 172.101 176.172 172.331 176.272 172.344C176.272 172.344 176.476 168.338 177.118 166.298C177.73 164.345 179.479 163.199 182.4 163.212C184.97 163.22 187.378 164.049 187.691 164.158C187.704 164.158 187.717 164.167 187.726 164.171L187.869 164.64C188.446 164.51 188.911 164.032 188.997 163.407C189.11 162.613 188.563 161.884 187.782 161.753Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M173.824 178.398C172.652 178.207 171.78 177.214 171.736 176.024L171.71 171.975C171.671 170.894 172.439 169.77 173.533 169.952C174.466 170.104 174.918 170.92 174.701 172.413"
      fill="#F3F3F3"
    />
    <path
      d="M173.824 178.398C172.652 178.207 171.78 177.214 171.736 176.024L171.71 171.975C171.671 170.894 172.439 169.77 173.533 169.952C174.466 170.104 174.918 170.92 174.701 172.413"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M197.452 260.477C198.507 286.003 204.761 313.424 204.622 316.393C204.184 325.616 200.321 369.44 200.321 369.44H187.418C187.418 369.44 184.549 336.463 184.549 327.865C184.549 309.852 180.382 317.396 175.842 294.293C174.366 286.793 168.759 260.486 168.78 260.482H197.457L197.452 260.477Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M196.02 270.512C194.922 286.931 168.78 369.44 168.78 369.44L153.008 365.139C153.008 365.139 161.302 328.776 163.043 320.694C164.874 310.304 159.761 277.847 160.174 270.516H196.016L196.02 270.512Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M194.058 213.715C191.658 208.468 187.721 202.148 182.956 197.391L182.93 197.37C181.298 195.742 179.57 194.306 177.773 193.155L175.942 191.658V190.226L163.22 183.872C163.22 183.872 158.728 194.918 158.147 197.396H158.181C157.444 199.774 157.153 202.917 157.296 207.062C157.661 217.465 157.687 261.897 158.733 276.25H194.575C196.159 276.25 197.444 274.965 197.444 273.381V233.238C197.444 224.262 195.59 217.088 194.049 213.72L194.058 213.715Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M178.997 199.327L194.844 232.357C195.466 233.43 196.534 234.206 198.047 234.683L222.461 244.835V252.361L187.483 249.575C186.207 249.562 185.074 248.763 184.627 247.569L165.621 203.711"
      fill="#F3F3F3"
    />
    <path
      d="M178.997 199.327L194.844 232.357C195.466 233.43 196.534 234.206 198.047 234.683L222.461 244.835V252.361L187.483 249.575C186.207 249.562 185.074 248.763 184.627 247.569L165.621 203.711"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M16.9271 366.693H0.434021V383.186H16.9271V366.693Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M325.955 185.859V227.526"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M317.078 173.507C318.434 172.15 320.632 172.15 321.988 173.507L371.093 222.611L366.182 227.522L317.078 178.417C315.721 177.061 315.721 174.863 317.078 173.507Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M305.122 279.609H548.177C555.846 279.609 562.066 273.39 562.066 265.72V196.276C562.066 186.688 554.293 178.915 544.705 178.915H430.122C405.816 178.915 393.75 200.499 367.622 213.637C338.29 228.385 305.122 224.054 305.122 248.359V279.609Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M548.177 224.054H499.566V189.332H541.233C545.069 189.332 548.177 192.439 548.177 196.276V224.054Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M496.094 189.332H447.483V224.054H496.094V189.332Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M444.01 224.054H379.67C378.012 224.054 377.296 221.953 378.611 220.942L419.705 189.332H444.01V224.054Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M447.483 272.665V227.526H492.4C494.319 227.526 495.872 229.08 495.872 230.998V252.083C488.52 256.337 483.303 263.858 482.205 272.665C482.153 272.665 482.101 272.665 482.049 272.665H447.483Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M444.01 272.665V227.526H378.038C376.12 227.526 374.566 229.08 374.566 230.998V252.083C381.918 256.337 387.135 263.858 388.233 272.665C388.286 272.665 388.338 272.665 388.39 272.665H444.01Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M489.149 234.47H478.733"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M437.066 234.47H426.649"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M562.066 206.693V244.887H555.122V213.637C555.122 209.805 558.234 206.693 562.066 206.693Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M555.122 224.054H562.066"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M555.122 234.47H562.066"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M336.372 276.137C336.372 289.562 347.253 300.443 360.677 300.443C374.102 300.443 384.983 289.562 384.983 276.137C384.983 262.713 374.102 251.832 360.677 251.832C347.253 251.832 336.372 262.713 336.372 276.137Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M349.323 276.137C349.323 282.409 354.405 287.491 360.677 287.491C366.949 287.491 372.031 282.409 372.031 276.137C372.031 269.865 366.949 264.783 360.677 264.783C354.405 264.783 349.323 269.865 349.323 276.137Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M485.677 276.137C485.677 289.562 496.558 300.443 509.983 300.443C523.407 300.443 534.288 289.562 534.288 276.137C534.288 262.713 523.407 251.832 509.983 251.832C496.558 251.832 485.677 262.713 485.677 276.137Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeLinejoin="round"
    />
    <path
      d="M336.623 262.248H305.122C303.203 262.248 301.649 263.802 301.649 265.72V279.609C301.649 281.528 303.203 283.082 305.122 283.082H333.776C333.203 280.864 332.899 278.537 332.899 276.137C332.899 271.076 334.258 266.332 336.623 262.248Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M332.389 233.745L315.62 238.238C314.694 238.486 314.144 239.438 314.392 240.364L316.19 247.072C316.438 247.998 317.39 248.548 318.316 248.3L335.085 243.806C336.012 243.558 336.561 242.606 336.313 241.68L334.516 234.972C334.268 234.046 333.316 233.496 332.389 233.745Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M534.288 438.464C547.136 438.464 557.552 427.776 557.552 414.592C557.552 401.408 547.136 390.72 534.288 390.72C521.44 390.72 511.024 401.408 511.024 414.592C511.024 427.776 521.44 438.464 534.288 438.464Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M524.462 414.058L534.288 424.141"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M544.115 414.058L534.288 424.141"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M534.288 424.141V505.373"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M458.247 395.321C458.247 414.306 473.637 429.696 492.622 429.696C511.606 429.696 526.997 414.306 526.997 395.321C526.997 384.119 521.636 374.167 513.338 367.891C514.748 364.918 515.538 361.593 515.538 358.082C515.538 345.425 505.278 335.165 492.622 335.165C479.965 335.165 469.705 345.425 469.705 358.082C469.705 361.589 470.49 364.918 471.905 367.891C463.607 374.167 458.247 384.119 458.247 395.321Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M475.434 383.863L492.621 398.186"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M509.809 383.863L492.622 398.186"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M492.622 398.186V505.373"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M466.84 392.457L492.622 412.509"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M518.403 392.457L492.622 412.509"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M701.415 106.363C694.787 106.363 688.624 108.329 683.459 111.701C676.515 101.845 665.052 95.3993 652.075 95.3993C631.78 95.3993 615.174 111.159 613.802 131.111C610.66 129.323 607.023 128.294 603.121 128.294C591.011 128.294 581.024 138.112 580.812 150.221C580.599 162.331 590.243 172.148 602.352 172.148H701.415C719.583 172.148 734.306 157.422 734.306 139.253C734.306 121.085 719.579 106.363 701.415 106.363Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M733.199 139.414C729.9 139.414 726.832 140.395 724.262 142.07C720.807 137.166 715.1 133.958 708.646 133.958C698.546 133.958 690.282 141.801 689.601 151.732C688.038 150.842 686.224 150.33 684.284 150.33C678.26 150.33 673.286 155.217 673.181 161.241C673.077 167.27 677.878 172.153 683.902 172.153H733.199C742.24 172.153 749.566 164.822 749.566 155.786C749.566 146.749 742.24 139.418 733.199 139.418V139.414Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M636.25 3.55468C634.362 3.55468 632.608 4.11458 631.141 5.07378C629.167 2.26996 625.903 0.434021 622.209 0.434021C616.432 0.434021 611.706 4.92187 611.315 10.599C610.421 10.0911 609.384 9.796 608.273 9.796C604.826 9.796 601.983 12.5911 601.923 16.0373C601.862 19.4835 604.609 22.2786 608.055 22.2786H636.25C641.419 22.2786 645.612 18.0859 645.612 12.9167C645.612 7.74739 641.419 3.55468 636.25 3.55468Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M296.567 504.31C296.567 504.31 276.398 504.353 274.592 504.353C274.592 501.029 288.72 499.089 288.72 495.269C288.72 491.58 288.72 487.982 288.72 487.982H298.464L296.567 504.31Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M292.73 416.467H295.451V415.764C295.451 415.764 336.684 403.477 353.659 403.477C360.26 403.477 361.753 420.056 361.753 428.008C361.753 434.701 356.163 440.447 349.418 440.447H303.372V489.822H282.157V427.049C282.157 421.207 286.892 416.467 292.739 416.467H292.73Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M357.205 505.304H298.902C298.902 505.304 296.597 449.87 296.597 446.506C296.597 443.142 299.284 440.412 302.669 440.412H353.746C357.131 440.412 359.666 443.142 359.666 446.506C359.666 449.87 357.205 505.304 357.205 505.304Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M273.915 504.336C273.915 501.332 283.064 499.501 285.534 497.878C287.118 496.836 291.033 500.699 293.329 500.699C297.101 500.699 297.504 497.105 297.504 497.105C297.504 497.105 298.798 500.291 298.602 504.284V505.299L274.431 505.373C274.149 505.373 273.924 504.991 273.924 504.523V504.514C273.924 504.453 273.928 504.392 273.937 504.332H273.924L273.915 504.336Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M326.706 504.31C326.706 504.31 305.187 504.31 303.381 504.31C303.381 500.985 317.509 499.089 317.509 495.269C317.509 491.58 317.509 487.982 317.509 487.982H328.602L326.706 504.31Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M303.038 503.45C303.32 500.503 312.305 498.728 314.757 497.118C316.354 496.068 318.676 499.965 320.994 499.965C324.805 499.965 328.229 496.337 328.229 496.337C328.229 496.337 329.535 499.557 329.336 503.589V505.299H303.021V503.446H303.034L303.038 503.45Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M321.003 416.467H324.922C331.953 410.76 342.956 403.477 353.277 403.477C359.878 403.477 361.371 420.056 361.371 428.008C361.371 434.701 355.781 440.447 349.036 440.447H331.58V489.822H310.421V427.049C310.421 421.207 315.156 416.467 321.003 416.467Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M319.01 324.258C319.01 324.258 317.036 325.117 317.036 334.006C317.036 339.492 315.998 339.479 315.998 345.577C315.998 351.328 319.991 354.731 319.991 354.731L337.296 354.722L337.335 324.245L319.01 324.254V324.258Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M367.63 406.697L366.358 397.47L361.593 361.849H361.584C361.181 359.167 359.097 357.135 356.549 356.714C356.224 356.593 355.885 356.493 355.538 356.415L342.122 353.407C341.128 353.186 340.339 352.938 340.339 351.914V345.781C340.43 344.032 340.807 342.977 341.615 341.35H341.575C344.262 338.963 345.916 335.43 345.777 331.51C345.542 324.892 340.117 319.544 333.542 319.449C326.597 319.349 320.937 324.991 320.937 331.962V333.494L319.21 336.793C318.841 337.478 318.989 338.563 319.757 338.85L320.924 339.284L320.916 346.046C320.916 347.773 322.292 349.18 324.023 349.18C324.54 349.18 325.916 348.841 326.68 348.841C328.242 348.841 328.151 350.299 328.151 351.91C328.151 352.452 327.99 352.813 327.726 353.069C327.4 353.377 326.914 353.529 326.363 353.646L313.034 356.471C312.569 356.571 312.122 356.71 311.697 356.884C309.366 357.461 307.504 359.401 307.127 361.923H307.118L307.088 362.144C306.927 362.747 306.836 363.377 306.823 364.023L302.131 397.543L300.859 404.644C300.13 408.715 302.535 413.194 306.458 414.41L312.917 416.402L355.573 416.467H362.031C365.959 415.252 368.364 410.773 367.63 406.701V406.697Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M367.63 406.662L366.359 397.4L361.593 361.641H361.584C361.181 358.945 359.097 356.91 356.549 356.489C356.224 356.367 355.885 356.263 355.538 356.185L342.122 353.164C342.023 353.142 341.931 353.121 341.836 353.095C340.755 355.859 338.095 357.821 334.974 357.821C331.884 357.821 328.828 355.543 327.73 352.817C327.73 352.817 327.496 353.138 326.367 353.398C323.051 354.158 313.038 356.237 313.038 356.237C312.574 356.337 312.127 356.476 311.701 356.649C309.371 357.227 307.509 359.18 307.131 361.706H307.122L307.092 361.927C306.931 362.53 306.84 363.164 306.827 363.815L302.135 397.461L300.864 404.588C300.135 408.676 302.539 413.173 306.463 414.392L312.921 416.389L355.577 416.454H362.036C365.964 415.234 368.368 410.738 367.635 406.649L367.63 406.662Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M344.948 348.589C344.948 341.732 348.147 339.47 348.147 330.36C348.147 321.172 338.173 314.609 331.237 318.142C331.237 318.142 327.565 315.451 323.563 316.944C318.724 318.75 319.015 324.258 319.015 324.258H323.542C323.542 324.258 328.906 324.266 328.906 333.429C328.906 336.458 333.689 336.419 333.689 333.394C333.689 332.452 334.536 331.953 335.239 331.953C336.61 331.953 337.604 333.264 337.231 334.583L336.376 337.621C336.146 338.446 335.083 339.414 334.245 339.496C334.245 339.496 333.468 342.695 333.485 345.586C333.52 352.036 333.412 363.858 340.347 363.858C349.492 363.858 349.501 354.922 349.501 354.922C349.501 354.922 344.961 352.912 344.961 348.589H344.948Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M323.099 336.432C324.206 336.432 325.104 334.73 325.104 332.63C325.104 330.53 324.206 328.828 323.099 328.828C321.992 328.828 321.094 330.53 321.094 332.63C321.094 334.73 321.992 336.432 323.099 336.432Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M325.1 333.398V331.871H334.97C334.97 331.871 334.44 332.036 334.036 332.465C333.633 332.895 333.681 333.398 333.681 333.398H325.1Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path d="M349.918 370.638L352.739 403.086H349.918" fill="#F3F3F3" />
    <path
      d="M349.918 370.638L352.739 403.086H349.918"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M349.922 403.772H343.381V416.467H349.922V403.772Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M318.112 369.965L313.837 403.477H324.206L318.112 369.965Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M344.271 416.467H294.905V379.787H344.275L344.271 416.467Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M319.592 402.361C321.929 402.361 323.824 400.466 323.824 398.129C323.824 395.792 321.929 393.898 319.592 393.898C317.255 393.898 315.36 395.792 315.36 398.129C315.36 400.466 317.255 402.361 319.592 402.361Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M645.399 293.498L637.405 245.043C634.635 234.918 624.084 228.902 613.958 231.675C603.833 234.444 597.491 245.182 600.261 255.304L608.941 293.498H645.399Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M622.591 281.806C622.591 281.806 623.407 272.491 618.581 268.507L613.594 270.013L611.931 270.512C610.095 271.068 608.16 270.026 607.604 268.19L605.599 261.541L603.941 261.445C602.973 261.359 602.444 260.517 602.608 259.562L603.598 254.892L602.595 251.567C600.104 243.307 604.779 234.588 613.042 232.101C621.306 229.609 630.022 234.284 632.513 242.548C633.524 245.907 633.355 249.34 632.24 252.4C630.521 263.173 638.233 272.062 642.539 275.79L622.591 281.806Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M620.773 257.873C622.07 257.457 622.895 256.181 622.743 254.826L622.092 250.221C621.953 248.984 620.89 247.839 619.679 248.229C618.646 248.559 618.268 249.562 618.767 251.224"
      fill="#F3F3F3"
    />
    <path
      d="M620.773 257.873C622.07 257.457 622.895 256.181 622.743 254.826L622.092 250.221C621.953 248.984 620.89 247.839 619.679 248.229C618.646 248.559 618.268 249.562 618.767 251.224"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M639.323 496.623C641.124 494.848 641.927 492.201 641.927 487.943C641.927 483.668 641.927 474.054 641.927 474.054H659.288V505.304H655.816V499.093C655.816 495.621 645.399 505.304 645.399 505.304H630.642C627.17 505.304 627.552 502.778 628.906 501.832C632.322 499.436 637.418 498.498 639.323 496.623Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M606.819 258.272C607.957 257.927 608.311 255.773 607.61 253.461C606.909 251.148 605.418 249.554 604.28 249.899C603.142 250.244 602.789 252.398 603.49 254.71C604.191 257.022 605.682 258.617 606.819 258.272Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M619.8 248.446L607.418 252.817"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M580.295 496.623C582.096 494.848 582.899 492.201 582.899 487.943C582.899 483.668 582.899 474.054 582.899 474.054H600.26V505.304H596.788V499.093C596.788 495.621 586.372 505.304 586.372 505.304H571.615C568.142 505.304 568.524 502.778 569.878 501.832C573.294 499.436 578.39 498.498 580.295 496.623Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M607.205 328.22C607.205 314.332 603.733 310.859 603.733 303.915C603.733 299.323 608.585 293.194 614.149 286.554C621.766 277.465 624.566 272.665 633.246 272.665C641.927 272.665 645.399 275.664 645.399 293.498C645.399 305.651 645.399 316.068 645.399 328.22H607.205Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M614.149 290.026L628.038 300.443"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M575.903 491.415C575.903 491.415 604.592 362.791 610.677 345.582L647.678 363.798C644.206 373.62 637.244 378.533 635.243 383.342C626.367 404.709 607.192 491.419 607.192 491.419H575.898L575.903 491.415Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M646.129 382.018C645.343 376.871 650.139 367.109 650.139 356.693C650.139 344.54 645.399 335.165 645.399 328.22H607.205C607.205 380.022 634.983 491.415 634.983 491.415H666.233C666.233 491.415 649.544 404.462 646.129 382.018Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M625.499 271.194C630.278 274.813 634.618 271.845 639.314 273.841C643.385 275.569 644.31 280.79 644.31 280.79C644.31 280.79 640.017 258.459 637.4 245.039C635.72 236.428 624.28 228.203 613.954 231.671C604.688 234.787 601.992 241.411 601.992 241.411C601.992 241.411 615.317 263.477 625.495 271.189L625.499 271.194Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M550.755 302.07L545.469 301.411L544.505 296.25C544.436 295.777 543.993 295.451 543.516 295.521C543.038 295.59 542.717 296.033 542.786 296.51L543.477 302.552C543.55 303.03 543.924 303.385 544.379 303.455L550.343 304.64C551.055 304.753 551.723 304.271 551.836 303.559C551.949 302.847 551.467 302.179 550.755 302.066V302.07Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M550.673 302.062L544.922 301.697L543.52 296.185C543.416 295.716 542.956 295.421 542.487 295.521C542.018 295.625 541.723 296.085 541.823 296.554L543.003 302.96C543.108 303.433 543.503 303.759 543.958 303.802L550.417 304.653C551.133 304.722 551.771 304.197 551.84 303.481C551.91 302.765 551.385 302.127 550.668 302.057L550.673 302.062Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M563.073 300.443H543.698C543.295 300.443 542.969 300.769 542.969 301.172V301.45C542.969 301.852 543.295 302.179 543.698 302.179H563.073C563.476 302.179 563.802 301.852 563.802 301.45V301.172C563.802 300.769 563.476 300.443 563.073 300.443Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M526.085 276.137C526.085 289.562 536.966 300.443 550.391 300.443C563.815 300.443 574.696 289.562 574.696 276.137C574.696 262.713 563.815 251.832 550.391 251.832C536.966 251.832 526.085 262.713 526.085 276.137Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M539.036 276.137C539.036 282.409 544.119 287.491 550.391 287.491C556.662 287.491 561.745 282.409 561.745 276.137C561.745 269.865 556.662 264.783 550.391 264.783C544.119 264.783 539.036 269.865 539.036 276.137Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M615.916 291.354C612.483 295.269 604.501 305.868 600.625 311.063C598.659 310.23 596.341 309.253 594.779 308.594C588.854 306.089 568.633 299.158 565.681 298.151C565.208 297.891 558.216 294.549 558.216 294.549C557.678 294.236 557.062 294.071 556.441 294.08L552.023 293.98L547.969 293.88C547.509 296.645 551.554 296.576 551.988 296.589C553.72 296.632 555.438 298.715 555.438 298.715C555.378 300.434 549.922 302.188 549.922 302.188H544.714L542.5 297.279C542.313 296.836 541.806 296.628 541.363 296.814C540.92 297.001 540.712 297.509 540.898 297.951L543.051 303.637C543.22 304.045 543.611 304.288 544.023 304.301L550.091 304.67C550.113 304.67 550.135 304.666 550.156 304.666H563.069C565.66 306.063 579.214 313.325 590.729 318.19C593.928 319.54 600.325 322.244 600.325 322.244C602.457 323.147 604.852 322.517 606.289 320.855C606.758 320.399 622.27 304.657 626.788 299.501L615.924 291.354H615.916Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M550.082 304.661C550.082 304.661 550.126 304.657 550.148 304.657H563.06C565.651 306.055 579.206 313.316 590.72 318.181C593.919 319.531 600.317 322.235 600.317 322.235C602.448 323.138 604.844 322.509 606.28 320.846C606.749 320.391 622.261 304.648 626.779 299.492L615.916 291.345C612.483 295.26 604.501 305.859 600.625 311.055C598.659 310.221 596.341 309.245 594.779 308.585C588.854 306.081 568.633 299.149 565.681 298.142C565.208 297.882 558.216 294.54 558.216 294.54C557.678 294.227 557.062 294.062 556.441 294.071L552.023 293.971L547.969 293.872C547.509 296.636 551.554 296.567 551.988 296.58C553.72 296.623 555.438 298.707 555.438 298.707C555.378 300.425 549.922 302.179 549.922 302.179"
      fill="#F3F3F3"
    />
    <path
      d="M550.082 304.661C550.082 304.661 550.126 304.657 550.148 304.657H563.06C565.651 306.055 579.206 313.316 590.72 318.181C593.919 319.531 600.317 322.235 600.317 322.235C602.448 323.138 604.844 322.509 606.28 320.846C606.749 320.391 622.261 304.648 626.779 299.492L615.916 291.345C612.483 295.26 604.501 305.859 600.625 311.055C598.659 310.221 596.341 309.245 594.779 308.585C588.854 306.081 568.633 299.149 565.681 298.142C565.208 297.882 558.216 294.54 558.216 294.54C557.678 294.227 557.062 294.062 556.441 294.071L552.023 293.971L547.969 293.872C547.509 296.636 551.554 296.567 551.988 296.58C553.72 296.623 555.438 298.707 555.438 298.707C555.378 300.425 549.922 302.179 549.922 302.179"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M732.096 45.4557C728.963 45.4557 726.05 46.3845 723.611 47.9774C720.33 43.3203 714.913 40.2734 708.78 40.2734C699.188 40.2734 691.341 47.7214 690.694 57.1484C689.21 56.3021 687.491 55.816 685.647 55.816C679.926 55.816 675.204 60.4557 675.104 66.1762C675.004 71.901 679.562 76.5408 685.282 76.5408H732.092C740.677 76.5408 747.635 69.5833 747.635 60.9983C747.635 52.4132 740.677 45.4557 732.092 45.4557H732.096Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M56.4236 326.784C56.4236 322.229 52.7315 318.537 48.1771 318.537C43.6227 318.537 39.9306 322.229 39.9306 326.784C39.9306 331.338 43.6227 335.03 48.1771 335.03C52.7315 335.03 56.4236 331.338 56.4236 326.784Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
    <path
      d="M729.167 432.387C729.167 427.833 725.475 424.141 720.92 424.141C716.366 424.141 712.674 427.833 712.674 432.387C712.674 436.942 716.366 440.634 720.92 440.634C725.475 440.634 729.167 436.942 729.167 432.387Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.918981"
      strokeMiterlimit="10"
    />
  </g>
  <defs>
    <clipPath id="clip0_203_144">
      <rect width="750" height="505.807" fill="white" />
    </clipPath>
  </defs>
</svg>`;
